module.exports = __webpack_public_path__ + "img/1531368072.20df9311.jpg";